export default "__VITE_ASSET__D26guGV2__"